import React from "react";
import PropTypes from "prop-types";
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from "chart.js";
import { Bar } from "react-chartjs-2";
import { formatDailyLabel } from "../../../app/utils/dateTimeUtils";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

export const options = {
  responsive: true,
  plugins: {
    legend: {
      position: "top",
    },
    title: {
      display: true,
      text: "DAILY",
      color: "white",
      font: {
        family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
        size: 23,
      },
    },
  },
  scales: {
    x: {
      title: {
        color: "white", // X-axis label color
      },
      ticks: {
        color: "white", // X-axis ticks color
      },
    },
    y: {
      title: {
        color: "white", // Y-axis label color
      },
      ticks: {
        color: "white", // Y-axis ticks color
      },
    },
  },
};

const DailyAttendance = ({ dailyDatas = [] }) => {
  const chartData = {
    labels: dailyDatas.map((d) => formatDailyLabel(d.date)),
    datasets: [
      {
        label: "",
        data: dailyDatas.map((d) => d.totalPresent),
        backgroundColor: "white",
      },
    ],
  };

  return (
    <div className="daily-attendance-container">
      <Bar options={options} data={chartData} />
    </div>
  );
};

DailyAttendance.propTypes = {
  dailyDatas: PropTypes.arrayOf(
    PropTypes.shape({
      date: PropTypes.string,
      totalPresent: PropTypes.number,
    }),
  ),
};

export default DailyAttendance;
